export { default as InsuranceLanding } from "./InsuranceLanding/InsuranceLanding";
export {
  InsuranceGiLandingPageMainWrapper,
  InsuranceLandingPageMainWrapper,
} from "./InsuranceLanding/InsuranceLanding.style";
